import React from "react";
import { CGE } from "../../../../common/components/CGE";

function SeguimientoSolicitud({ props }) {

    return (
        <CGE.Panel
            title={"En esta sección podrás:"}
            description={
                <>
                    Ver el estado de tu solicitud ingresada (pendiente de aprobación, aprobada o rechazada), además de ver la fecha de ingreso para esta solicitud.
                    <br/>
                    <strong>Importante (*)</strong> el tiempo máximo de respuesta es de 48 hrs hábiles.
                </>
            }
        >
            <>
                <CGE.FormsField
                    horizontal={true}
                    labelName="Número solicitud:"
                    value={props.nroSolicitud}
                    idFormElement="numberSolicitud"
                    typeFormElement="text"
                    typeElement={'input'}
                    readOnly={true}
                />
                <CGE.FormsField
                    horizontal={true}
                    labelName="Fecha ingreso:"
                    value={props.fechaIngresoSolicitud}
                    idFormElement="dateAdimission"
                    typeFormElement="text"
                    typeElement={'input'}
                    readOnly={true}
                />
                <CGE.FormsField
                    horizontal={true}
                    labelName="Estado:"
                    value={props.estado}
                    idFormElement="status"
                    typeFormElement="text"
                    typeElement={'input'}
                    readOnly={true}
                />
            </>
        </CGE.Panel>
    )
}
export default SeguimientoSolicitud